import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home/Home";
import Category from "./components/Category/Category";
import SingleProduct from "./components/SingleProduct/SingleProduct";
import Newsletter from "./components/Footer/Newsletter/Newsletter";
// import Categoryy from "./components/SaleCategory/Category/Categories";
import AppContext, { Context } from "./utils/context";
import Login from "./components/Login/Login";
import Registration from "./components/Registration/Registration";
import Logout from "./components/Logout/Logout";
import { ToastContainer } from "react-toastify";
// import ProductList from "./components/MainProduct/ProductList";
import { useContext, useState } from "react";
import CheckoutPage from "./components/Checkout/CheckoutPage";
import SaleCategory from "./components/SaleCategory/SaleCategory";
import Categories from "./components/SaleCategory/Category/Categories";
import MainProducts from "./components/MainProducts/MainProducts";
import { Protector } from "./helpers";
import DisplayProducts from "./components/DisplayProducts/DisplayProducts";
import MainSingleProduct from "./components/MainProducts/MainSingleProduct/MainSingleProduct";
import DisplaySaleCategory from "./components/displaySaleCategory/DisplaySaleCategory";
import SaleProducts from "./components/SaleCategory/SaleProducts/SaleProducts";
import CategorySingleProduct from "./components/SaleCategory/ProductCategorySingle/CategorySingleProduct";
// import Categories from "./components/SaleCategory/Category/Categories";
// import { Context } from "./utils/context";
function App() {

  return (
    
    <BrowserRouter>
      <AppContext>
     
      <Header />
      <>

        <Routes>
       <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registeration" element={<Registration />}/>
          <Route path="/logout" element={<Logout />} />
          <Route path="/category/:id" element={<Category />} />
          <Route path="/salecategory/:id" element={<Categories />} />
          <Route path="/product/:id" element={<SingleProduct />} />
          <Route path="/saleproduct/:id" element={<CategorySingleProduct />} />

          <Route path="/salecategories/:id" element={<SaleProducts  />} />
          <Route path="/salecategories" element={<DisplaySaleCategory />} />
          <Route path="/displayproduct" element={<DisplayProducts />} />
          <Route path="/displayproduct/:id" element={<MainSingleProduct />} />

          </Routes>
        <Newsletter />
        <Footer />
        
        </>
      </AppContext>
      <ToastContainer />
      
    </BrowserRouter>
    
  );
}

export default App;
